import React from 'react'
import { Select } from 'SRC/ui/FormElements'

export class BirthDate extends React.PureComponent {
  days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]
  months = ['Januar', 'Februar', 'Mart', 'April', 'Maj', 'Jun', 'Jul', 'Avgust', 'Septembar', 'Oktobar', 'Novembar', 'Decembar']

  getYears = () => {
    const years = []
    const end = 1900
    for (let start = new Date().getFullYear(); start >= end; start--) {
      years.push(start)
    }
    return years
  }

  getDayField = () => ({
    id: 'day',
    name: 'day',
    options: this.days.map((day, index) => ({
      id: index,
      label: `${day}`,
      value: day,
      isDisabled: false
    })),
    label: '',
    labelDefault: 'Dan',
    needColon: false
  })

  getMonthField = () => ({
    id: 'month',
    name: 'month',
    options: this.months.map((month, index) => ({
      id: index,
      label: month,
      value: index,
      isDisabled: false
    })),
    label: '',
    labelDefault: 'Mjesec',
    needColon: false
  })

  getYearField = () => ({
    id: 'year',
    name: 'year',
    options: this.getYears().map((year, index) => ({
      id: index,
      label: `${year}`,
      value: year,
      isDisabled: false
    })),
    label: '',
    labelDefault: 'Godina',
    needColon: false
  })

  render () {
    const dayField = this.getDayField()
    const monthField = this.getMonthField()
    const yearField = this.getYearField()
    return (
      <div className='form-datum-rodjenja'>
        <label>Datum rođenja:</label>
        <Select {...dayField} />
        <Select {...monthField} />
        <Select {...yearField} />
      </div>
    )
  }
}
